import { useState } from 'react';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/system';
import { useForm } from "react-hook-form";
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';

import RequiredFields from "@components/common/HookFormMui/RequiredFields";
import useErrorHandling from '@components/common/hooks/useErrorHandling';
import useTrimField from '@components/common/hooks/useTrimField';

const ParticipantForm = ({ participant, onSubmit }) => {

  const [wasSubmitting, setWasSubmitting] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onSubmit',
    values: {
      first_name: participant?.first_name,
      middle_name: participant?.middle_name,
      last_name: participant?.last_name,
    }
  });

  useErrorHandling({ errors, isSubmitting, wasSubmitting, setWasSubmitting });

  // makeTransform adds a transformer that allows spaces to be trimmed from the input without affecting the display input
  const makeTransform = useTrimField();

  return (
    <Box width={'100%'}>
      <FormContainer onSuccess={handleSubmit(onSubmit)} FormProps={{ className: 'mui' }}>
        <RequiredFields/>
        <Grid container columns={12} spacing={2}>
          <Grid xs={12}>
            <TextFieldElement
              id="field-first_name"
              name="first_name"
              label={'First Name'}
              control={control}
              required
              fullWidth
              transform={makeTransform('first_name')}
            />
          </Grid>

          <Grid xs={12}>
            <TextFieldElement
              id="field-middle_name"
              name="middle_name"
              label={'Middle Name'}
              control={control}
              fullWidth
              transform={makeTransform('middle_name')}
            />
          </Grid>

          <Grid xs={12}>
            <TextFieldElement
              id="field-last_name"
              name="last_name"
              label={'Last Name'}
              control={control}
              required
              fullWidth
              transform={makeTransform('last_name')}
            />
          </Grid>

          <Grid xs={12}>
            <Button
              id="button-submit"
              variant="contained"
              size="small"
              type="submit"
              disabled={isSubmitting}
              sx={{ marginTop: '20px' }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </FormContainer>
    </Box>
  );
};

export default ParticipantForm;
